/**
 * 导出记录功能上线日期，弹窗提示「Exports made before ... aren't listed.」用
 * TODO 上线时替换成实际上线日期
 */
export const EXPORT_HISTORY_LAUNCH_DATE = "2026-10-29"
